/**
 * useMainScorecard — Plan 05-12 Task 2.
 *
 * TanStack Query hook for GET /api/main/scorecard.
 * Single call populates all ~45 tiles from one payload.
 *
 * Config:
 *   - queryKey: ['main', 'scorecard']
 *   - staleTime: 5 min — matches the cache refresh cadence (7 min cron);
 *     5 min ensures we re-fetch before cache is stale
 *   - retry: 2 — standard for blips
 *
 * The hook is used by MainScorecardPage to populate all 3 tabs.
 * Inactive-tab snap queries are gated externally via `enabled: activeTab === X`.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiFetch } from '../lib/api-client.js';

import type { MainScorecardResponse } from '@saledash/shared';

export function useMainScorecard(): UseQueryResult<MainScorecardResponse> {
  return useQuery<MainScorecardResponse>({
    queryKey: ['main', 'scorecard'],
    queryFn: ({ signal }) =>
      apiFetch<MainScorecardResponse>('/api/main/scorecard', { signal }),
    staleTime: 5 * 60_000,
    retry: 2,
  });
}
